// import { useEffect } from "react";
// import { useDispatch } from "react-redux";
// import socket from "../../assets/socketConnection";
// import { fetchStatusAsync } from "../../redux/instantReq/instantReq.actions";
import { useEffect, useState } from "react";
import { Animated } from "react-animated-css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import socket from "../../assets/socketConnection";
import LoadingPage from "../../components/loadingPage/loadingPage.component";
import { clearStatusShowing } from "../../redux/instantReq/instantReq.actions";
import { selectInstantShowingStatus } from "../../redux/instantReq/instantReq.selectors";
import { InstantReqPageWaitingStyled } from "./instantReqPageWaiting.styles";

const InstantReqPageWaiting = () => {
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  const params = useParams();
  const browserHistory = useHistory();
  const showingStatus = useSelector(selectInstantShowingStatus);

  useEffect(() => {
    // effect
    dispatch(clearStatusShowing());
    // return () => {
    //   alert("bye");
    // };
  }, []);

  socket.on("response_member_cancels_instant_request", (data) => {
    console.log(data);
    setShowLoading(false);
    if (data.status === 1) {
      browserHistory.push("/reqs");
    }
  });

  const onCancelClick = () => {
    setShowLoading(true);
    console.log({ load_id: params.id });
    socket.emit("member_cancels_instant_request", { load_id: params.id });
  };
  return (
    <>
      <LoadingPage isShow={showLoading} />

      <InstantReqPageWaitingStyled>
        <div className="inner">
          {showingStatus.slice(0, 3)?.map((item, index) => (
            <Animated
              animationIn="bounceInRight"
              animationOut="bounceOutRight"
              animationInDuration={1000}
              animationOutDuration={1000}
              isVisible={true}
              className="animated position-relative d-flex flex-column-reverse"
            >
              <div className={`inner__white item-${index}`}>
                {item.description}
              </div>
            </Animated>
          ))}
        </div>
        <div className="text-center">
          <button
            onClick={onCancelClick}
            className="btn btn-danger cancel-btn my-3"
          >
            لغو درخواست
          </button>
        </div>
      </InstantReqPageWaitingStyled>
    </>
  );
};

export default InstantReqPageWaiting;
